import { Navigate } from "react-router";

export function HomeRedirect() {
  return <Navigate to={"/inbox"} replace />;
}
